import { Messages } from '~src/codegen/Localize';

import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import {TabDialogWidth} from '../../commonInfra/dialogs/style/TabDialogWidth';
import {IResult} from '../../httpClient/serverApi/types/IResponse';
import { ResolveAmbiguousUserIdentityConflictDialogBody, ResolveAmbiguousUserIdentityConflictDialogBodyProps, ResolveAmbiguousUserIdentityConflictDialogBodyState } from '../components/ResolveAmbiguousUserIdentityConflictDialogBody';
import { IUserIdentityConflict } from '../requests/types/IUserIdentityConflict';
import { UserIdentityConflictsService } from '../services/UserIdentityConflictsService';

export function showResolveAmbiguousUserIdentityConflict(conflict: IUserIdentityConflict): Promise<IResult> {
  const modalInstance = openReactActionDialog<ResolveAmbiguousUserIdentityConflictDialogBodyProps, ResolveAmbiguousUserIdentityConflictDialogBodyState, IResult>({
    title: Messages.identityMigration_ResolveAmbiguousUserIdentityConflictDialogTitle(),
    bodyComponent: ResolveAmbiguousUserIdentityConflictDialogBody,
    initialBodyProps: { conflict },
    initialDialogState: { dataRecordId: '', selectedIndex: -1},
    actionName: Messages.identityMigration_ResolveAmbiguousUserIdentityConflictDialogAction(),
    action: handleAmbiguousConflictResolution,
    dialogWidth: TabDialogWidth.width600px,
    dismissDialogOnActionFailed: true,
  });

  return modalInstance.result;
}


function handleAmbiguousConflictResolution(bodyProps: ResolveAmbiguousUserIdentityConflictDialogBodyProps,
    dialogState: ResolveAmbiguousUserIdentityConflictDialogBodyState) {
  return UserIdentityConflictsService.resolveAmbiguousUserIdentityConflict(bodyProps.conflict.id, dialogState.dataRecordId);
}